// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604081450/js/" + chunkId + "." + {"44":"acf81b6f","225":"23c64700","481":"bb3284f6","486":"14f0f427","770":"b0e39dff"}[chunkId] + ".0.96014447230707.chunk.js";
};